import twLocale from 'element-ui/lib/locale/lang/zh-TW' //引入element语言包
const tw = {
  posterPage: {
    title1:'訂閱功能即將上線！',
    title2:'訂閱續費，特權陞級！',
    title3:'專屬折扣，續費更划算',
    title4:'獲取兌換碼，您可以諮詢購買設備的銷售商家',
    title5:'優先體驗功能',
    function1:'功能詳情：',
    function2:'基礎服務續費（同傳翻譯、會議助理、智能助手）..',
    function3:'增值服務訂閱（離線翻譯、音視頻通話翻譯）..',
  },
  RedemptionCodePage: {
    RedemptionCode: '兌換碼',
    ValueAddedServices: '增值服務',
    UpgradedExperience: '專屬增值權益，體驗陞級',
    OfflineTranslation: '離線翻譯',
    NoInternet: '無需聯網·即時翻譯·安全可靠',
    GoToSubscribe: '去訂閱',
    AudioAndVideoCall: '音/視頻通話',
    RealTimeCall: '實时語音轉譯·溝通無障礙',
    BaseService: '基礎服務',
    AIAssistant: '功能：同傳翻譯·會議助理·AI助手',
    LanguagesSetting:'語言設定',
    languages1:'簡體中文',
    languages2:'繁體中文',
    languages3:'英文',
    languages4:'日語',
    languages5:'韓語',
    languages6:'俄語',
    languages7:'西班牙語',
    languages8:'法語',
    languages9:'德語',
    languages10:'葡萄牙語',
    languages11:'義大利語',
    languages12:'土耳其語',
    languages13:'越南語',
    languages14:'印尼語',
    languages15:'印地語',
    languages16:'阿拉伯語',
    languages17:'泰語',
    languages18:'波斯語',
  },
  Login: {
    ToLogin: '登入',
    PhoneLogin: '手機號登入',
    EmailLogin: '郵箱登錄',
    PhonePlaceholder: '請輸入手機號',
    EmailPlaceholder: 'Enter email',
    Code: '驗證碼',
    and: '和',
    BeforeText: '創建帳戶的同時代表你同意並遵守',
    UserAgreement: '使用者協定',
    privacy: '隱私政策',
    errorMessage: '驗證碼錯誤',
    readTitle: '閱讀並同意以下協定',
    readBefore: '為保證您的個人資訊安全，請先閱讀並同意',
    cancel: '取消',
    agree: '同意並繼續',
    error1:'請輸入有效的郵箱地址',
    error2:'請輸入正確的手機號',
    error3:'請輸入驗證碼',
    success:'登入成功'
  },
  OffLinePage: {
    title: '離線翻譯',
    NoInternet: '無需聯網·即時翻譯·安全可靠',
    ServiceLife: '使用期限',
    forever: '永久使用',
    describe: '訂閱說明',
    describeItem1: '1.離線翻譯功能為一次性付費，永久使用，使用許可權跟隨藍牙設備，如果更換設備，需重新訂閱離線翻譯兌換碼。',
    describeItem2: '2.授權碼訂閱後不可退費。',
    describeItem3: '3.支持10種語言：中文、英語、德語、日語、韓語、印地語、泰語、西班牙語、法語、俄語。',
    quantity: '數量',
    payType: '支付方式',
    card: '銀行卡',
    wx: '微信',
    GooglePay: 'Google Pay',
    subscribe: '訂閱',
    RMB: '¥',
    confirm:'確認',
    cardNumber:'卡號',
    periodOfValidity:'有效期',
    safetyCode:'安全碼',
    name:'姓名',
    yearAndMonth:'年份/月份',
    message1:'數量不能為0',
    popTip:'溫馨提示',
    popText1:'請您仔細閱讀並理解',
    popText2:'離線翻譯付費協定',
    popText3:'我已閱讀並同意',
    popText4:'已閱讀並同意',
  },
  AudioVideoPage: {
    title: '音/視頻通話',
    RealTime: '實时語音轉譯·溝通無障礙',
    describe: '訂閱說明',
    describeItem1: '1.音視頻通話翻譯功能為充值購買分鐘數，分鐘數從接通通話開始計算時長，許可權跟隨帳號，如果登入其它帳號，需重新充值。',
    describeItem2: '2.帳號充值後連接和綁定不同設備能照常使用。',
    describeItem3: '3.音視頻通話翻譯功能充值後不可退費。',
    payType: '支付方式',
    card: '银行卡',
    wx: '微信',
    GooglePay: 'Google Pay',
    subscribe: '訂閱',
    RMB: '¥',
    sale: '折扣',
    confirm:'確認',
    time1:'秒',
    time2:'分鐘',
    time3:'小時',
    time4:'天',
    time5:'月',
    time6:'年',
  },
  OffLineResult: {
    title1: '離線翻譯',
    title2: '音/視頻通話',
    title3: '基礎服務',
    success: '訂閱成功',
    fail: '訂閱失敗',
    stock:'兌換碼備貨中...',
    saveTitle: '保存兌換碼，前往APP進行兌換使用',
    code: '兌換碼',
    tip1: '此碼僅用於兌換離線翻譯功能',
    tip2: '此碼僅用於兌換音/視頻通話翻譯功能',
    tip3: '此碼僅用於兌換基礎服務續費功能',
    save: '保存',
    time: '訂閱時間：',
    copy: '複製',
    copySuccess: '複製成功',
    loading:'加載中...',
    paySuccess:'支付成功'
  },
  RedemptionList: {
    title: '我的兌換碼',
    view: '查看',
    time: '訂閱時間：',
  },
  MyRedemption: {
    title: '我的兌換碼',
    code: '兌換碼',
    time: '訂閱時間：',
    copy: '複製',
    tip1: '此碼僅用於兌換離線翻譯功能',
    tip2: '此碼僅用於兌換音/視頻通話翻譯功能',
    tip3: '此碼僅用於兌換基礎服務續費功能',
    save: '保存',
    success:"操作成功"
  },
  basePage:{
    error1:'沒有獲取到商品資訊',
    message1:'請選擇商品',
    title:'基礎服務',
    function:'功能：同傳翻譯·會議助理·AI助手',
    describe: '訂閱說明',
    describe1:'1.同傳翻譯、會議助理等基礎服務續費之後，有效期跟隨設備，如果更換設備，需重新續費。',
    describe2:'2.基礎服務續費後不可退費。',
    payType: '支付方式',
    card: '银行卡',
    wx: '微信',
    GooglePay: 'Google Pay',
    subscribe: '訂閱',
    RMB: '¥',
    sale: '折扣',
    month:'月',
    confirm:'確認',
    month1:'1個月',
    month2:'半年',
    month3:'1年'
  },
  ...twLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default tw;
